/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetComputeUsageRequest = {
  from?: Date | undefined;
  to?: Date | undefined;
  resourceType?: components.ComputeResourceType | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type GetComputeUsageResponse =
  | components.ComputeUsage
  | components.ComputeErrorEnvelope;

/** @internal */
export const GetComputeUsageRequest$inboundSchema: z.ZodType<
  GetComputeUsageRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  from: z.string().datetime({ offset: true }).transform(v => new Date(v))
    .optional(),
  to: z.string().datetime({ offset: true }).transform(v => new Date(v))
    .optional(),
  resource_type: components.ComputeResourceType$inboundSchema.optional(),
  cursor: z.string().optional(),
  limit: z.number().int().default(50),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "resource_type": "resourceType",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetComputeUsageRequest$Outbound = {
  from?: string | undefined;
  to?: string | undefined;
  resource_type?: string | undefined;
  cursor?: string | undefined;
  limit: number;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetComputeUsageRequest$outboundSchema: z.ZodType<
  GetComputeUsageRequest$Outbound,
  z.ZodTypeDef,
  GetComputeUsageRequest
> = z.object({
  from: z.date().transform(v => v.toISOString()).optional(),
  to: z.date().transform(v => v.toISOString()).optional(),
  resourceType: components.ComputeResourceType$outboundSchema.optional(),
  cursor: z.string().optional(),
  limit: z.number().int().default(50),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    resourceType: "resource_type",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getComputeUsageRequestToJSON(
  getComputeUsageRequest: GetComputeUsageRequest,
): string {
  return JSON.stringify(
    GetComputeUsageRequest$outboundSchema.parse(getComputeUsageRequest),
  );
}
export function getComputeUsageRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetComputeUsageRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetComputeUsageRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetComputeUsageRequest' from JSON`,
  );
}

/** @internal */
export const GetComputeUsageResponse$inboundSchema: z.ZodType<
  GetComputeUsageResponse,
  z.ZodTypeDef,
  unknown
> = z.union([
  components.ComputeUsage$inboundSchema,
  components.ComputeErrorEnvelope$inboundSchema,
]);
/** @internal */
export type GetComputeUsageResponse$Outbound =
  | components.ComputeUsage$Outbound
  | components.ComputeErrorEnvelope$Outbound;

/** @internal */
export const GetComputeUsageResponse$outboundSchema: z.ZodType<
  GetComputeUsageResponse$Outbound,
  z.ZodTypeDef,
  GetComputeUsageResponse
> = z.union([
  components.ComputeUsage$outboundSchema,
  components.ComputeErrorEnvelope$outboundSchema,
]);

export function getComputeUsageResponseToJSON(
  getComputeUsageResponse: GetComputeUsageResponse,
): string {
  return JSON.stringify(
    GetComputeUsageResponse$outboundSchema.parse(getComputeUsageResponse),
  );
}
export function getComputeUsageResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetComputeUsageResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetComputeUsageResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetComputeUsageResponse' from JSON`,
  );
}
